import { BaseSerializer } from "./baseSerializer.ts";
import { ListSizeOverTime } from "../listSizeOverTime.model.ts";
export class ListSizeOverTimeSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new ListSizeOverTime();
        this._copyAttributes(gp, data);
        return gp;

    }

}
